webpackJsonp([1],{

/***/ "+yMS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @param {*} any
 * @returns {Boolean}
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isObject(any) {
  return any !== null && (typeof any === 'undefined' ? 'undefined' : _typeof(any)) === 'object';
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
var isArray = Array.isArray;
/**
 * @param {*} any
 * @returns {Boolean}
 */

function isArrayLike(any) {
  if (!isObject(any)) return false;
  if (!('length' in any)) return false;
  var length = any.length;
  if (!isNumber(length)) return false;
  if (length > 0) {
    return length - 1 in any;
  } else {
    for (var key in any) {
      return false;
    }
  }
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
function isNumber(any) {
  return typeof any === 'number';
}
/**
 * @param {Object|Array} object
 * @returns {Array<String>}
 */
function getKeys(object) {
  var keys_ = Object.keys(object);
  if (isArray(object)) {
    // skip sort
  } else if (isArrayLike(object)) {
    var index = keys_.indexOf('length');
    if (index > -1) {
      keys_.splice(index, 1);
    }
    // skip sort
  } else {
    // sort
    keys_.sort();
  }
  return keys_;
}

exports.getKeys = getKeys;
exports.isArray = isArray;
exports.isArrayLike = isArrayLike;
exports.isObject = isObject;
exports.isNumber = isNumber;

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "36e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages_scss__ = __webpack_require__("eZgH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__messages_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__ = __webpack_require__("/4ic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nanogql__ = __webpack_require__("ZxKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nanogql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nanogql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__query__ = __webpack_require__("z3JB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);


var _templateObject = _taggedTemplateLiteralLoose(['\n      query Query($input: ListSubmissionsInput, $identity: String) {\n          listSubmissions(input: $input, identity: $identity) {\n              name,\n              email,\n              phone,\n              message,\n              created_at,\n              sequence\n          }\n      }\n    '], ['\n      query Query($input: ListSubmissionsInput, $identity: String) {\n          listSubmissions(input: $input, identity: $identity) {\n              name,\n              email,\n              phone,\n              message,\n              created_at,\n              sequence\n          }\n      }\n    ']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var _ref3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'div',
  { className: 'feedback-loader' },
  'Loading...'
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'div',
  { className: 'feedback-header' },
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'h1',
    null,
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-comments' }),
    '\xA0\xA0Feedback'
  )
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Date'
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Name'
);

var _ref7 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Email'
);

var _ref8 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Phone'
);

var _ref9 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Message'
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      messages: [],
      hasMore: true
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.loadMore = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loadMoreQueue = this.loadMoreQueue || Promise.resolve(null);
              return _context.abrupt('return', this.loadMoreQueue = this.loadMoreQueue.then(this.loadMoreQueued.bind(this)).catch(console.warn));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function loadMore() {
      return _ref.apply(this, arguments);
    }

    return loadMore;
  }();

  _default.prototype.loadMoreQueued = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _this2 = this;

      var limit, query, response, newMessages, messages;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              limit = 15;
              query = __WEBPACK_IMPORTED_MODULE_4_nanogql___default()(_templateObject);
              _context2.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_5__query__["a" /* default */])(query, {
                input: {
                  valid: true,
                  skip: this.state.messages.length,
                  limit: limit
                }
              });

            case 4:
              response = _context2.sent;
              newMessages = response.listSubmissions;
              messages = this.state.messages.concat(newMessages);
              _context2.next = 9;
              return new Promise(function (resolve) {
                return _this2.setState({
                  messages: messages,
                  hasMore: newMessages.length === limit
                }, resolve);
              });

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function loadMoreQueued() {
      return _ref2.apply(this, arguments);
    }

    return loadMoreQueued;
  }();

  _default.prototype.render = function render() {

    /*
     <div className="input-wrapper">
     <input type="text" placeholder="Search Feedback" />
     <label><i className="fa fa-search" /></label>
     </div>
     */
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default.a,
      {
        pageStart: 0,
        loadMore: this.loadMore.bind(this),
        hasMore: this.state.hasMore,
        loader: _ref3
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'feedback' },
        _ref4,
        this.state.messages.map(function (message, index) {
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'feedback-row', key: index },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'feedback-row-details' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                null,
                _ref5,
                __WEBPACK_IMPORTED_MODULE_6_moment___default()(message.created_at).format('ddd, MMM Do YYYY, h:mm A')
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                null,
                _ref6,
                message.name
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                null,
                _ref7,
                message.email
              ),
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                null,
                _ref8,
                message.phone
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'feedback-row-message' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'p',
                null,
                _ref9,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                  'span',
                  null,
                  message.message
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'feedback-row-sequence' },
              'Feedback #',
              message.sequence
            )
          );
        })
      )
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);



/***/ }),

/***/ "AOkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invitations_scss__ = __webpack_require__("qkWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invitations_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__invitations_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_select__ = __webpack_require__("Xv0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_email_validator__ = __webpack_require__("WWPA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_email_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_email_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nanogql__ = __webpack_require__("ZxKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nanogql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_nanogql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__query__ = __webpack_require__("z3JB");


var _templateObject = _taggedTemplateLiteralLoose(['{\n        getUserPortalGroupNames\n    }'], ['{\n        getUserPortalGroupNames\n    }']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n        mutation Mutation($input: [CreateInvitationInput]!) {\n            createInvitations(input: $input)\n        }\n    '], ['\n        mutation Mutation($input: [CreateInvitationInput]!) {\n            createInvitations(input: $input)\n        }\n    ']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var _ref4 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'h1',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-envelope-o' }),
  '\xA0\xA0Invitations'
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spinner' });

var _ref6 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Name'
);

var _ref7 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Email'
);

var _ref8 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Group'
);

var _ref9 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'button',
  { className: 'border-only' },
  'Delete'
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      invitations: [],
      name: '',
      email: '',
      group: 'Default',
      editing: false,
      groups: [{
        label: 'Default',
        value: 'Default'
      }],
      sending: false,
      sent: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.componentDidMount = function componentDidMount() {
    this.fetchGroupNames().catch(console.warn);
  };

  _default.prototype.fetchGroupNames = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      var query, result, groups;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = __WEBPACK_IMPORTED_MODULE_5_nanogql___default()(_templateObject);
              _context.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(query);

            case 3:
              result = _context.sent;

              if (Array.isArray(result.getUserPortalGroupNames)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return');

            case 6:
              groups = (result.getUserPortalGroupNames || []).map(function (name) {
                return {
                  label: name,
                  value: name
                };
              });


              this.setState({
                groups: groups
              });

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchGroupNames() {
      return _ref.apply(this, arguments);
    }

    return fetchGroupNames;
  }();

  _default.prototype.onGroupSelection = function onGroupSelection(group) {
    this.setState({
      group: group
    });
  };

  _default.prototype.edit = function edit(invitation) {
    if (this.state.name || this.state.email) {
      return;
    }
    this.setState({
      editing: invitation,
      name: invitation.name,
      email: invitation.email,
      group: invitation.group
    });
  };

  _default.prototype.isGroupValid = function isGroupValid(group) {
    if (!group) {
      return false;
    }
    return !!this.state.groups.find(function (option) {
      return option.value.toLowerCase().trim() === group.toLowerCase().trim();
    });
  };

  _default.prototype.canAdd = function canAdd() {
    return this.state.name && __WEBPACK_IMPORTED_MODULE_4_email_validator___default.a.validate(this.state.email) && this.isGroupValid(this.state.group);
  };

  _default.prototype.allValid = function allValid() {
    var _this2 = this;

    return !this.state.invitations.find(function (invitation) {
      return !(invitation.name && __WEBPACK_IMPORTED_MODULE_4_email_validator___default.a.validate(invitation.email) && _this2.isGroupValid(invitation.group));
    });
  };

  _default.prototype.onAdd = function onAdd() {
    if (!this.canAdd()) {
      return;
    }

    var invitations = this.state.invitations.slice();

    var invitation = {
      name: this.state.name,
      email: this.state.email,
      group: this.state.group
    };

    if (this.state.editing) {
      var index = invitations.indexOf(this.state.editing);

      if (index === -1) {
        invitations.unshift(invitation);
      } else {
        invitations[index] = invitation;
      }
    } else {
      invitations.unshift(invitation);
    }

    this.setState({
      invitations: invitations,
      name: '',
      email: '',
      editing: false
      // Retain group so they can keep on adding
    });
  };

  _default.prototype.sendInvite = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _this3 = this;

      var result;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.state.editing || !this.canAdd())) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              _context2.next = 4;
              return this.sendInvites([{
                name: this.state.name,
                email: this.state.email,
                group: this.state.group
              }], true);

            case 4:
              result = _context2.sent;

              if (result) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt('return');

            case 7:
              _context2.next = 9;
              return new Promise(function (resolve) {
                return _this3.setState({
                  name: '',
                  email: ''
                }, resolve);
              });

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function sendInvite() {
      return _ref2.apply(this, arguments);
    }

    return sendInvite;
  }();

  _default.prototype.sendInvites = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(invites) {
      var _this4 = this;

      var retainInvites = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var promise, query, result;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              promise = new Promise(function (resolve) {
                return _this4.setState({
                  sending: true,
                  sent: false
                }, resolve);
              });
              query = __WEBPACK_IMPORTED_MODULE_5_nanogql___default()(_templateObject2);
              result = void 0;
              _context3.prev = 3;
              _context3.next = 6;
              return Object(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(query, {
                input: invites
              });

            case 6:
              result = _context3.sent;
              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3['catch'](3);

              result = {
                createInvitations: false
              };

            case 12:

              console.log(result);

              _context3.next = 15;
              return promise;

            case 15:
              _context3.next = 17;
              return new Promise(function (resolve) {
                return _this4.setState({
                  sending: false,
                  sent: !!result.createInvitations
                }, resolve);
              });

            case 17:
              if (result.createInvitations) {
                _context3.next = 20;
                break;
              }

              alert('Invitations failed to send');
              return _context3.abrupt('return', false);

            case 20:
              if (!retainInvites) {
                _context3.next = 22;
                break;
              }

              return _context3.abrupt('return', true);

            case 22:
              _context3.next = 24;
              return new Promise(function (resolve) {
                return _this4.setState({
                  invitations: []
                }, resolve);
              });

            case 24:
              return _context3.abrupt('return', true);

            case 25:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[3, 9]]);
    }));

    function sendInvites(_x) {
      return _ref3.apply(this, arguments);
    }

    return sendInvites;
  }();

  _default.prototype.render = function render() {
    var _this5 = this;

    /*
      <button>
     Upload CSV
     </button>
     */

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'invitations' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'invitations-header' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'header-wrapper' },
          _ref4,
          this.state.sending ? _ref5 : null,
          this.state.sent || this.state.sending ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: 'invitations-sent ' + (this.state.sending ? 'sending' : '') },
            'Invitations sent!'
          ) : null
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'invitations-new' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'invitations-new-group' },
          _ref6,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
            type: 'text',
            placeholder: 'Name',
            value: this.state.name,
            name: 'name',
            onChange: function onChange(event) {
              var _this5$setState;

              return _this5.setState((_this5$setState = {}, _this5$setState[event.target.name] = event.target.value, _this5$setState));
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'invitations-new-group' },
          _ref7,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
            type: 'text',
            placeholder: 'Email',
            value: this.state.email,
            name: 'email',
            onChange: function onChange(event) {
              var _this5$setState2;

              return _this5.setState((_this5$setState2 = {}, _this5$setState2[event.target.name] = event.target.value, _this5$setState2));
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'invitations-new-group' },
          _ref8,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_select__["a" /* default */], {
            placeholder: 'Select Group',
            options: this.state.groups,
            value: this.state.group,
            onChange: this.onGroupSelection.bind(this)
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'invitations-new-group invitations-new-button-group' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { onClick: this.onAdd.bind(this),
              disabled: this.state.sending || !this.canAdd() },
            this.state.editing ? 'Save' : 'Add'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'invitations-new-group invitations-new-button-group' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { className: 'secondary', disabled: this.state.sending || this.state.editing || !this.canAdd(), onClick: this.sendInvite.bind(this) },
            'Send Invite'
          )
        )
      ),
      this.state.invitations.map(function (invitation, index) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'invitation-row', key: index },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            { className: invitation.name ? '' : 'invalid' },
            invitation.name
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_4_email_validator___default.a.validate(invitation.email) ? '' : 'invalid' },
            invitation.email
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            { className: _this5.isGroupValid(invitation.group) ? '' : 'invalid' },
            invitation.group
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            {
              className: 'border-only',
              disabled: !!(_this5.state.name || _this5.state.email),
              onClick: _this5.edit.bind(_this5, invitation)
            },
            'Edit'
          ),
          _ref9
        );
      }),
      this.state.invitations.length ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'invitations-footer' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'button',
          { disabled: this.state.sending || !this.allValid(), onClick: this.sendInvites.bind(this, this.state.invitations, false) },
          'Send Invite to all'
        )
      ) : null
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);



/***/ }),

/***/ "AXXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nanogql__ = __webpack_require__("ZxKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nanogql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nanogql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");


var _templateObject = _taggedTemplateLiteralLoose(['\n        mutation Mutation($input:CreateIdentityTokenInput!){\n            createIdentityToken(input:$input) {\n                token,\n                success\n            }\n        }\n    '], ['\n        mutation Mutation($input:CreateIdentityTokenInput!){\n            createIdentityToken(input:$input) {\n                token,\n                success\n            }\n        }\n    ']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Authentication = function () {
  function Authentication() {
    _classCallCheck(this, Authentication);

    this.onAuthenticationChangeListeners = [];

    this.getToken();
  }

  Authentication.prototype.authenticate = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(username, password) {
      var query, response, data;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = __WEBPACK_IMPORTED_MODULE_1_nanogql___default()(_templateObject);
              _context.next = 3;
              return fetch('' + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api.host + __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].api.path, {
                method: 'POST',
                body: JSON.stringify(query({
                  input: {
                    username: username,
                    password: password
                  }
                })),
                headers: {
                  'Content-Type': 'application/json'
                }
              });

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.json();

            case 6:
              data = _context.sent.data.createIdentityToken;

              if (data && data.success) {
                _context.next = 10;
                break;
              }

              throw new Error('Failed to login');

            case 10:

              localStorage.setItem('access_token', JSON.stringify(data.token));

              return _context.abrupt('return', this.authenticationChange());

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function authenticate(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return authenticate;
  }();

  Authentication.prototype.isAuthenticated = function isAuthenticated() {
    return !!this.getToken();
  };

  Authentication.prototype.getToken = function getToken() {
    var token = localStorage.getItem('access_token');
    if (!token) {
      return null;
    }
    try {
      return JSON.parse(token);
    } catch (e) {
      return null;
    }
  };

  Authentication.prototype.unauthenticate = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.isAuthenticated()) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              localStorage.removeItem('access_token');
              return _context2.abrupt('return', this.authenticationChange());

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function unauthenticate() {
      return _ref2.apply(this, arguments);
    }

    return unauthenticate;
  }();

  Authentication.prototype.authenticationChange = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', this.onAuthenticationChangeListeners.filter(function (fn) {
                return fn instanceof Function;
              }).reduce(function (promise, fn) {
                return promise.then(fn);
              }, Promise.resolve(null)));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function authenticationChange() {
      return _ref3.apply(this, arguments);
    }

    return authenticationChange;
  }();

  Authentication.prototype.onAuthenticationChange = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(fn) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.onAuthenticationChangeListeners.includes(fn)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt('return', function () {
                return null;
              });

            case 2:
              if (fn instanceof Function) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt('return', function () {
                return null;
              });

            case 4:
              this.onAuthenticationChangeListeners.push(fn);
              return _context4.abrupt('return', function () {
                var index = _this.onAuthenticationChangeListeners.indexOf(fn);
                console.log('Removing', index);
                if (index === -1) {
                  return;
                }
                _this.onAuthenticationChangeListeners.splice(index, 1);
              });

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function onAuthenticationChange(_x3) {
      return _ref4.apply(this, arguments);
    }

    return onAuthenticationChange;
  }();

  return Authentication;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Authentication());

/***/ }),

/***/ "BCsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_input_scss__ = __webpack_require__("NWlF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_input_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__file_input_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var FileInput = function (_React$Component) {
  _inherits(FileInput, _React$Component);

  function FileInput() {
    _classCallCheck(this, FileInput);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  FileInput.prototype.render = function render() {
    var _this2 = this;

    var id = 'file-input-' + Math.random().toString().replace(/\./, '');

    var _props = this.props,
        onChange = _props.onChange,
        children = _props.children,
        rest = _objectWithoutProperties(_props, ['onChange', 'children']);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'label',
      { className: 'file-input', htmlFor: id, onClick: function onClick() {
          return _this2.ref.click();
        } },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', _extends({
        type: 'file',
        onChange: function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
            return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return onChange(event);

                  case 2:
                    event.target.value = null;

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }(),
        name: id,
        id: id,
        ref: function ref(_ref2) {
          return _this2.ref = _ref2;
        }
      }, rest)),
      children
    );
  };

  return FileInput;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);



/***/ }),

/***/ "HIM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_scss__ = __webpack_require__("ruU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__settings_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slugify__ = __webpack_require__("wffv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_file_input__ = __webpack_require__("BCsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nanogql__ = __webpack_require__("ZxKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nanogql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_nanogql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__query__ = __webpack_require__("z3JB");


var _templateObject = _taggedTemplateLiteralLoose(['query Query($id: ObjectID!){\n        getPortalSettings(id: $id) {\n            _id,\n            email,\n            name,\n            facebookReviewLink,\n            googleReviewLink,\n            headerImage,\n            footerImage,\n            logo,\n            website,\n            directorInfo,\n            groups {\n                facebookReviewLink,\n                googleReviewLink,\n                name,\n                disabled\n            }\n        }      \n      }'], ['query Query($id: ObjectID!){\n        getPortalSettings(id: $id) {\n            _id,\n            email,\n            name,\n            facebookReviewLink,\n            googleReviewLink,\n            headerImage,\n            footerImage,\n            logo,\n            website,\n            directorInfo,\n            groups {\n                facebookReviewLink,\n                googleReviewLink,\n                name,\n                disabled\n            }\n        }      \n      }']),
    _templateObject2 = _taggedTemplateLiteralLoose(['{\n            getUserPortalSettings {\n                _id,\n                email,\n                name,\n                facebookReviewLink,\n                googleReviewLink,\n                headerImage,\n                footerImage,\n                logo,\n                website,\n                directorInfo,\n                groups {\n                    facebookReviewLink,\n                    googleReviewLink,\n                    name,\n                    disabled\n                }\n            }\n        }'], ['{\n            getUserPortalSettings {\n                _id,\n                email,\n                name,\n                facebookReviewLink,\n                googleReviewLink,\n                headerImage,\n                footerImage,\n                logo,\n                website,\n                directorInfo,\n                groups {\n                    facebookReviewLink,\n                    googleReviewLink,\n                    name,\n                    disabled\n                }\n            }\n        }']),
    _templateObject3 = _taggedTemplateLiteralLoose(['        \n      mutation Mutation($input: UploadFileInput!, $identity: String) {\n          uploadFile(input: $input, identity: $identity) {\n              success,\n              url\n          }\n      }\n    '], ['        \n      mutation Mutation($input: UploadFileInput!, $identity: String) {\n          uploadFile(input: $input, identity: $identity) {\n              success,\n              url\n          }\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n      mutation Mutation($input: UpdatePortalSettingsInput!) {\n          updatePortalSettings(input: $input)\n      }\n    '], ['\n      mutation Mutation($input: UpdatePortalSettingsInput!) {\n          updatePortalSettings(input: $input)\n      }\n    ']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var _ref4 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'h1',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-cogs' }),
  '\xA0\xA0Settings'
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spinner' });

var _ref6 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Company Logo'
);

var _ref7 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'button',
  null,
  'Upload Logo'
);

var _ref8 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spinner' });

var _ref9 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'p',
  { className: 'error' },
  'Unable to upload file'
);

var _ref10 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Header Image'
);

var _ref11 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'button',
  null,
  'Upload Image'
);

var _ref12 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spinner' });

var _ref13 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'p',
  { className: 'error' },
  'Unable to upload file'
);

var _ref14 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Footer Image'
);

var _ref15 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'button',
  null,
  'Upload Image'
);

var _ref16 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spinner' });

var _ref17 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'p',
  { className: 'error' },
  'Unable to upload file'
);

var _ref18 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Director Info'
);

var _ref19 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Email'
);

var _ref20 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-envelope' })
);

var _ref21 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Website'
);

var _ref22 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-globe' })
);

var _ref23 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Facebook Review Link'
);

var _ref24 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-facebook' })
);

var _ref25 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Google Review Link'
);

var _ref26 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-google' })
);

var _ref27 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'settings-company-group' });

var _ref28 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'div',
  { className: 'settings-header' },
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'h1',
    null,
    'Groups'
  )
);

var _ref29 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Add Group'
);

var _ref30 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Facebook Review Link'
);

var _ref31 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-facebook' })
);

var _ref32 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Google Review Link'
);

var _ref33 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-google' })
);

var _ref34 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Name'
);

var _ref35 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Facebook Review Link'
);

var _ref36 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-facebook' })
);

var _ref37 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  'Google Review Link'
);

var _ref38 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'fa fa-google' })
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      saving: false,
      dirty: false,
      logoLoading: false,
      headerImageLoading: false,
      footerImageLoading: false,
      logoError: false,
      headerImageError: false,
      footerImageError: false,
      settings: {
        name: '',
        email: '',
        facebookReviewLink: '',
        googleReviewLink: '',
        headerImage: '',
        footerImage: '',
        logo: '',
        website: '',
        directorInfo: '',
        groups: []
      },
      newGroup: {
        name: '',
        facebookReviewLink: '',
        googleReviewLink: ''
      },
      loading: true
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.componentDidMount = function componentDidMount() {
    this.fetchSettings().catch(console.warn);
  };

  _default.prototype.fetchSettings = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this2 = this;

      var promise, query, result, settings;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              promise = new Promise(function (resolve) {
                return _this2.setState({
                  loading: true
                }, resolve);
              });
              query = (this.props.match.params || {}).portal ? __WEBPACK_IMPORTED_MODULE_5_nanogql___default()(_templateObject) : __WEBPACK_IMPORTED_MODULE_5_nanogql___default()(_templateObject2);
              _context.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(query, {
                id: (this.props.match.params || {}).portal
              });

            case 4:
              result = _context.sent;
              settings = result.getUserPortalSettings || result.getPortalSettings || this.state.settings;
              _context.next = 8;
              return promise;

            case 8:
              return _context.abrupt('return', new Promise(function (resolve) {
                return _this2.setState({
                  loading: false,
                  settings: settings
                }, resolve);
              }));

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchSettings() {
      return _ref.apply(this, arguments);
    }

    return fetchSettings;
  }();

  _default.prototype.onExistingGroupDisabled = function onExistingGroupDisabled(group, disabled) {
    var groups = this.state.settings.groups.slice(),
        index = groups.indexOf(group);

    var object = Object.assign({}, group, {
      disabled: !disabled
    });

    if (index === -1) {
      groups.unshift(object);
    } else {
      groups[index] = object;
    }

    this.setState({
      settings: Object.assign({}, this.state.settings, {
        groups: groups
      }),
      dirty: true
    });
  };

  _default.prototype.onExistingGroupInputChange = function onExistingGroupInputChange(group, event) {
    var _Object$assign;

    var groups = this.state.settings.groups.slice(),
        index = groups.indexOf(group);

    var object = Object.assign({}, group, (_Object$assign = {}, _Object$assign[event.target.name] = event.target.value, _Object$assign));

    if (index === -1) {
      groups.push(object);
    } else {
      groups[index] = object;
    }

    this.setState({
      settings: Object.assign({}, this.state.settings, {
        groups: groups
      }),
      dirty: true
    });
  };

  _default.prototype.onNewGroupInputChange = function onNewGroupInputChange(event) {
    var _Object$assign2;

    this.setState({
      newGroup: Object.assign({}, this.state.newGroup, (_Object$assign2 = {}, _Object$assign2[event.target.name] = event.target.value, _Object$assign2))
    });
  };

  _default.prototype.onSettingsInputChange = function onSettingsInputChange(event) {
    var _Object$assign3;

    this.setState({
      settings: Object.assign({}, this.state.settings, (_Object$assign3 = {}, _Object$assign3[event.target.name] = event.target.value, _Object$assign3)),
      dirty: true
    });
  };

  _default.prototype.addNewGroup = function addNewGroup() {
    if (!this.canAddGroup()) {
      return;
    }
    var groups = this.state.settings.groups.slice();
    groups.unshift(this.state.newGroup);
    this.setState({
      settings: Object.assign({}, this.state.settings, {
        groups: groups
      }),
      newGroup: {
        name: '',
        facebookReviewLink: '',
        googleReviewLink: ''
      },
      dirty: true
    });
  };

  _default.prototype.canAddGroup = function canAddGroup() {
    var _this3 = this;

    if (!this.state.newGroup.name || typeof this.state.newGroup.name !== 'string') {
      return false;
    }
    var slug = __WEBPACK_IMPORTED_MODULE_3_slugify___default()(this.state.newGroup.name);
    return !this.state.settings.groups.find(function (group) {
      return _this3.state.newGroup.name.toLowerCase() === group.name.toLowerCase() || slug.toLowerCase() === __WEBPACK_IMPORTED_MODULE_3_slugify___default()(group.name).toLowerCase();
    });
  };

  _default.prototype.uploadFile = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(key, event) {
      var _this4 = this;

      var promise, file, query, result;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (event.target.files && event.target.files.length) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              promise = new Promise(function (resolve) {
                var _this4$setState;

                return _this4.setState((_this4$setState = {}, _this4$setState[key + 'Loading'] = true, _this4$setState[key + 'Error'] = false, _this4$setState), resolve);
              });

              /**
               * @type {File}
               */

              file = event.target.files[0];
              query = __WEBPACK_IMPORTED_MODULE_5_nanogql___default()(_templateObject3);
              result = void 0;
              _context2.prev = 6;
              _context2.next = 9;
              return Object(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(query, {
                input: {
                  lastModified: file.lastModified || file.lastModifiedDate.getTime(),
                  name: file.name,
                  type: file.type,
                  size: file.size,
                  contents: file
                }
              });

            case 9:
              result = _context2.sent;
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](6);

              result = {
                uploadFile: {
                  success: false,
                  url: ''
                }
              };

            case 15:
              _context2.next = 17;
              return promise;

            case 17:
              return _context2.abrupt('return', new Promise(function (resolve) {
                var _Object$assign4, _this4$setState2;

                return _this4.setState((_this4$setState2 = {}, _this4$setState2[key + 'Loading'] = false, _this4$setState2[key + 'Error'] = !result.uploadFile.success, _this4$setState2.settings = Object.assign({}, _this4.state.settings, (_Object$assign4 = {}, _Object$assign4[key] = result.uploadFile.success ? result.uploadFile.url : _this4.state.settings[key], _Object$assign4)), _this4$setState2.dirty = result.uploadFile.success || _this4.state.dirty, _this4$setState2), resolve);
              }));

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[6, 12]]);
    }));

    function uploadFile(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return uploadFile;
  }();

  _default.prototype.save = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _this5 = this;

      var promise, query, result;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (this.state.dirty) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt('return');

            case 2:
              if (this.state.settings._id) {
                _context3.next = 5;
                break;
              }

              alert('Can not identify review portal to save');
              return _context3.abrupt('return');

            case 5:
              promise = new Promise(function (resolve) {
                return _this5.setState({
                  saving: true
                }, resolve);
              });
              query = __WEBPACK_IMPORTED_MODULE_5_nanogql___default()(_templateObject4);
              result = void 0;
              _context3.prev = 8;
              _context3.next = 11;
              return Object(__WEBPACK_IMPORTED_MODULE_6__query__["a" /* default */])(query, {
                input: Object.assign({}, this.state.settings || {}, {
                  _id: undefined,
                  name: undefined
                })
              });

            case 11:
              result = _context3.sent;
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3['catch'](8);

              result = {
                updatePortalSettings: false
              };

            case 17:

              if (!result.updatePortalSettings) {
                alert('Unable to save settings');
              }

              _context3.next = 20;
              return promise;

            case 20:
              return _context3.abrupt('return', new Promise(function (resolve) {
                return _this5.setState({
                  saving: false,
                  dirty: !result.updatePortalSettings
                }, resolve);
              }));

            case 21:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[8, 14]]);
    }));

    function save() {
      return _ref3.apply(this, arguments);
    }

    return save;
  }();

  _default.prototype.render = function render() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'settings' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'settings-header' },
        _ref4,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'save-wrapper' },
          this.state.saving ? _ref5 : null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { disabled: !this.state.dirty || this.state.saving, onClick: this.save.bind(this) },
            'Save'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'settings-company' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'settings-company-group' },
          _ref6,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: this.state.settings.logo || '/images/placeholder.png' }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__components_file_input__["a" /* default */],
            { onChange: this.uploadFile.bind(this, 'logo') },
            _ref7,
            this.state.logoLoading ? _ref8 : null
          ),
          this.state.logoError ? _ref9 : null
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'settings-company-group' },
          _ref10,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: this.state.settings.headerImage || '/images/placeholder.png' }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__components_file_input__["a" /* default */],
            { onChange: this.uploadFile.bind(this, 'headerImage') },
            _ref11,
            this.state.headerImageLoading ? _ref12 : null
          ),
          this.state.headerImageError ? _ref13 : null
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'settings-company-group' },
          _ref14,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: this.state.settings.footerImage || '/images/placeholder.png' }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__components_file_input__["a" /* default */],
            { onChange: this.uploadFile.bind(this, 'footerImage') },
            _ref15,
            this.state.footerImageLoading ? _ref16 : null
          ),
          this.state.footerImageError ? _ref17 : null
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'settings-company' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'settings-company-group' },
          _ref18,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('textarea', { placeholder: 'Director Info', rows: '3', name: 'directorInfo', value: this.state.settings.directorInfo, onChange: this.onSettingsInputChange.bind(this) }),
          _ref19,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'input-wrapper' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'text', placeholder: 'Email', name: 'email', value: this.state.settings.email, onChange: this.onSettingsInputChange.bind(this) }),
            _ref20
          ),
          _ref21,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'input-wrapper' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'text', placeholder: 'Website', name: 'website', value: this.state.settings.website, onChange: this.onSettingsInputChange.bind(this) }),
            _ref22
          ),
          _ref23,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'input-wrapper' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'text', placeholder: 'Facebook Review Link', name: 'facebookReviewLink', value: this.state.settings.facebookReviewLink, onChange: this.onSettingsInputChange.bind(this) }),
            _ref24
          ),
          _ref25,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'input-wrapper' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { type: 'text', placeholder: 'Google Review Link', name: 'googleReviewLink', value: this.state.settings.googleReviewLink, onChange: this.onSettingsInputChange.bind(this) }),
            _ref26
          )
        ),
        _ref27
      ),
      _ref28,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'settings-group-new' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'settings-group-new-input' },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'settings-group-new-input-group' },
            _ref29,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
              type: 'text',
              placeholder: 'Name',
              name: 'name',
              value: this.state.newGroup.name,
              onChange: this.onNewGroupInputChange.bind(this)
            })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'settings-group-new-input-group' },
            _ref30,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'input-wrapper' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
                type: 'text',
                placeholder: 'Facebook Review Link',
                name: 'facebookReviewLink',
                value: this.state.newGroup.facebookReviewLink,
                onChange: this.onNewGroupInputChange.bind(this)
              }),
              _ref31
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'settings-group-new-input-group' },
            _ref32,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'input-wrapper' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
                type: 'text',
                placeholder: 'Google Review Link',
                name: 'googleReviewLink',
                value: this.state.newGroup.googleReviewLink,
                onChange: this.onNewGroupInputChange.bind(this)
              }),
              _ref33
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'button',
          { disabled: !this.canAddGroup(), onClick: this.addNewGroup.bind(this) },
          'Add'
        )
      ),
      this.state.settings.groups.map(function (group, index) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'settings-group', key: index },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'settings-group-new-input' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'settings-group-new-input-group' },
              _ref34,
              group.name
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'settings-group-new-input-group' },
              _ref35,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'input-wrapper' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
                  type: 'text',
                  placeholder: 'Facebook Review Link',
                  name: 'facebookReviewLink',
                  value: group.facebookReviewLink,
                  onChange: _this6.onExistingGroupInputChange.bind(_this6, group),
                  disabled: group.disabled
                }),
                _ref36
              )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'settings-group-new-input-group' },
              _ref37,
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'input-wrapper' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
                  type: 'text',
                  placeholder: 'Google Review Link',
                  name: 'googleReviewLink',
                  value: group.googleReviewLink,
                  onChange: _this6.onExistingGroupInputChange.bind(_this6, group),
                  disabled: group.disabled
                }),
                _ref38
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'button',
            { className: group.disabled ? 'border-only' : '', onClick: _this6.onExistingGroupDisabled.bind(_this6, group, group.disabled) },
            group.disabled ? 'Enable' : 'Disable'
          )
        );
      })
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);



/***/ }),

/***/ "NWlF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  api: {
    host: 'https://api.reviews.nzdigital.co.nz',
    // host: 'http://localhost:8080',
    path: '/graphql'
  }
});

/***/ }),

/***/ "T74N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrivateRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication__ = __webpack_require__("AXXu");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PrivateRoute = function (_React$Component) {
  _inherits(PrivateRoute, _React$Component);

  function PrivateRoute() {
    var _temp, _this, _ret;

    _classCallCheck(this, PrivateRoute);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      round: 0
    }, _this.mounted = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PrivateRoute.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.mounted = true;
    this.unregister = __WEBPACK_IMPORTED_MODULE_2__authentication__["a" /* default */].onAuthenticationChange(function () {
      return new Promise(function (resolve) {
        if (!_this2.unregister || !_this2.mounted) {
          return resolve();
        }
        _this2.setState(function (state) {
          return {
            round: state.round + 1
          };
        }, resolve);
      });
    });
  };

  PrivateRoute.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
    if (this.unregister instanceof Function) {
      this.unregister();
      this.unregister = null;
    }
  };

  PrivateRoute.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        rest = _objectWithoutProperties(_props, ['component']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */], _extends({}, rest, {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_2__authentication__["a" /* default */].isAuthenticated() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */], {
          to: {
            pathname: '/login',
            state: { from: props.location }
          }
        });
      }
    }));
  };

  return PrivateRoute;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),

/***/ "Xv0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-caret-down' });

var SelectWrapper = function (_React$Component) {
  _inherits(SelectWrapper, _React$Component);

  function SelectWrapper() {
    _classCallCheck(this, SelectWrapper);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  SelectWrapper.prototype.render = function render() {
    var _this2 = this;

    var options = this.props.options;
    var valueIndex = options.filter(function (option) {
      return option;
    }).findIndex(function (option) {
      return option.value === _this2.props.value;
    });
    var id = this.props.name || this.props.id || 'select-' + Math.random().toString().replace(/\./, '');
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'input-wrapper input-wrapper-select' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        {
          name: this.props.name || id,
          id: this.props.id || id,
          value: valueIndex,
          onChange: function onChange(event) {
            return _this2.props.onChange((options[+event.target.value] || {}).value, options[+event.target.value], event.target.value);
          }
        },
        this.props.placeholder ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { disabled: true, value: -1 },
          this.props.placeholder
        ) : null,
        this.props.options.map(function (option, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: index, key: index },
            option.label
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { htmlFor: id },
        _ref
      )
    );
  };

  return SelectWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),

/***/ "bVQb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZgH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eslX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_scss__ = __webpack_require__("h5AK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_route__ = __webpack_require__("T74N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_login__ = __webpack_require__("q1rf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_header__ = __webpack_require__("w6Jx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_footer__ = __webpack_require__("ok73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_messages__ = __webpack_require__("36e0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_invitations__ = __webpack_require__("AOkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_settings__ = __webpack_require__("HIM7");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* BrowserRouter */],
  null,
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'app-wrapper' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_header__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'main',
      { className: 'app' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Switch */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */], { path: '/login', component: __WEBPACK_IMPORTED_MODULE_5__pages_login__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_route__["a" /* default */], { path: '/feedback', component: __WEBPACK_IMPORTED_MODULE_8__pages_messages__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_route__["a" /* default */], { path: '/invitations', component: __WEBPACK_IMPORTED_MODULE_9__pages_invitations__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_route__["a" /* default */], { path: '/settings', component: __WEBPACK_IMPORTED_MODULE_10__pages_settings__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_route__["a" /* default */], { path: '/settings/:portal', component: __WEBPACK_IMPORTED_MODULE_10__pages_settings__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */], { to: '/feedback' })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_footer__["a" /* default */], null)
  )
);

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  App.prototype.render = function render() {
    return _ref;
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),

/***/ "giXp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h5AK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kDB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss__ = __webpack_require__("iCOP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__("eslX");







Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* default */], null), document.querySelector('#app'));

/***/ }),

/***/ "ok73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer_scss__ = __webpack_require__("kDB2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__footer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'footer',
  { className: 'footer' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'p',
    null,
    'Design and Build by ',
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { href: 'https://nzdigital.co.nz' },
      'NZ Digital'
    )
  )
);

var _default = function (_React$PureComponent) {
  _inherits(_default, _React$PureComponent);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  _default.prototype.render = function render() {
    return _ref;
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);



/***/ }),

/***/ "q1rf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_scss__ = __webpack_require__("bVQb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__login_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication__ = __webpack_require__("AXXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("CIox");


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* Redirect */], { to: '/feedback' });

var _ref4 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'h3',
  null,
  'Login'
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  { htmlFor: 'username' },
  'Username'
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
  'label',
  { htmlFor: 'password' },
  'Password'
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      username: '',
      password: '',
      error: '',
      loading: false,
      success: false
    }, _this.onInputEvent = function (_ref) {
      var _this$setState;

      var target = _ref.target;
      var name = target.name,
          value = target.value;

      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * @param {Event} event
   * @returns {Promise}
   */
  _default.prototype.onSubmit = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(event) {
      var _this2 = this;

      var promise;
      return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              _context.next = 4;
              return new Promise(function (resolve) {
                return _this2.setState({
                  loading: true,
                  error: ''
                }, resolve);
              });

            case 4:
              promise = _context.sent;
              _context.prev = 5;
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__authentication__["a" /* default */].authenticate(this.state.username, this.state.password);

            case 8:
              _context.next = 16;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](5);

              console.warn(_context.t0);
              _context.next = 15;
              return promise;

            case 15:
              return _context.abrupt('return', new Promise(function (resolve) {
                return _this2.setState({
                  password: '',
                  error: 'The username or password provided is incorrect',
                  loading: false
                }, resolve);
              }));

            case 16:

              console.log("waiting promise");
              _context.next = 19;
              return promise;

            case 19:
              console.log("promise complete");

              return _context.abrupt('return', new Promise(function (resolve) {
                return _this2.setState({
                  password: '',
                  success: true
                }, resolve);
              }));

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 10]]);
    }));

    function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    }

    return onSubmit;
  }();

  _default.prototype.render = function render() {
    console.log(!this.loading && __WEBPACK_IMPORTED_MODULE_3__authentication__["a" /* default */].isAuthenticated() || this.state.success, this.state);
    if (!this.loading && __WEBPACK_IMPORTED_MODULE_3__authentication__["a" /* default */].isAuthenticated() || this.state.success) {
      return _ref3;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'login-container' },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'form',
        { className: 'login-form-container pure-form pure-form-stacked' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'fieldset',
          null,
          _ref4,
          this.state.error ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            { className: 'pure-form-message-inline error' },
            this.state.error
          ) : null,
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'pure-control-group' },
            _ref5,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { name: 'username', id: 'username', type: 'text', placeholder: 'Username', required: true, onChange: this.onInputEvent, value: this.state.username, disabled: this.loading })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'pure-control-group' },
            _ref6,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', { name: 'password', id: 'password', type: 'password', placeholder: 'Password', required: true, onChange: this.onInputEvent, value: this.state.password, disabled: this.loading })
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'pure-controls' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              { type: 'submit', onClick: this.onSubmit.bind(this), disabled: !(this.state.username && this.state.password) || this.loading },
              'Log in'
            )
          )
        )
      )
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);



/***/ }),

/***/ "qkWd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ruU/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "w6Jx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_scss__ = __webpack_require__("giXp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication__ = __webpack_require__("AXXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("F8kA");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],
  { to: '/', className: 'brand', activeClassName: 'brand-active' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-smile-o' }),
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fa fa-meh-o' }),
  '\xA0Reviews'
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'li',
  { className: 'menu-item' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],
    { to: '/invitations', className: 'menu-link', activeClassName: 'menu-link-active' },
    'Invitations'
  )
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'li',
  { className: 'menu-item' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],
    { to: '/feedback', className: 'menu-link', activeClassName: 'menu-link-active' },
    'Feedback'
  )
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'li',
  { className: 'menu-item' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],
    { to: '/settings', className: 'menu-link', activeClassName: 'menu-link-active' },
    'Settings'
  )
);

var _default = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      round: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.unregister = __WEBPACK_IMPORTED_MODULE_2__authentication__["a" /* default */].onAuthenticationChange(function () {
      return new Promise(function (resolve) {
        return _this2.setState(function (state) {
          return {
            round: state.round + 1
          };
        }, resolve);
      });
    });
  };

  _default.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unregister instanceof Function) {
      this.unregister();
      this.unregister = null;
    }
  };

  _default.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'header',
      { className: 'header' },
      _ref,
      __WEBPACK_IMPORTED_MODULE_2__authentication__["a" /* default */].isAuthenticated() ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        { className: 'menu-list' },
        _ref2,
        _ref3,
        _ref4,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'menu-item' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'menu-link', onClick: __WEBPACK_IMPORTED_MODULE_2__authentication__["a" /* default */].unauthenticate.bind(__WEBPACK_IMPORTED_MODULE_2__authentication__["a" /* default */]) },
            'Logout'
          )
        )
      ) : null
    );
  };

  return _default;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);



/***/ }),

/***/ "yBmp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__("+yMS"),
    isObject = _require.isObject,
    getKeys = _require.getKeys;

// PRIVATE PROPERTIES


var BYPASS_MODE = '__bypassMode';
var IGNORE_CIRCULAR = '__ignoreCircular';
var MAX_DEEP = '__maxDeep';
var CACHE = '__cache';
var QUEUE = '__queue';
var STATE = '__state';

var EMPTY_STATE = {};

var RecursiveIterator = function () {
  /**
   * @param {Object|Array} root
   * @param {Number} [bypassMode=0]
   * @param {Boolean} [ignoreCircular=false]
   * @param {Number} [maxDeep=100]
   */
  function RecursiveIterator(root) {
    var bypassMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var ignoreCircular = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var maxDeep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;

    _classCallCheck(this, RecursiveIterator);

    this[BYPASS_MODE] = bypassMode;
    this[IGNORE_CIRCULAR] = ignoreCircular;
    this[MAX_DEEP] = maxDeep;
    this[CACHE] = [];
    this[QUEUE] = [];
    this[STATE] = this.getState(undefined, root);
  }
  /**
   * @returns {Object}
   */


  RecursiveIterator.prototype.next = function next() {
    var _ref = this[STATE] || EMPTY_STATE,
        node = _ref.node,
        path = _ref.path,
        deep = _ref.deep;

    if (this[MAX_DEEP] > deep) {
      if (this.isNode(node)) {
        if (this.isCircular(node)) {
          if (this[IGNORE_CIRCULAR]) {
            // skip
          } else {
            throw new Error('Circular reference');
          }
        } else {
          if (this.onStepInto(this[STATE])) {
            var _QUEUE;

            var descriptors = this.getStatesOfChildNodes(node, path, deep);
            var method = this[BYPASS_MODE] ? 'push' : 'unshift';
            (_QUEUE = this[QUEUE])[method].apply(_QUEUE, descriptors);
            this[CACHE].push(node);
          }
        }
      }
    }

    var value = this[QUEUE].shift();
    var done = !value;

    this[STATE] = value;

    if (done) this.destroy();

    return { value: value, done: done };
  };
  /**
   *
   */


  RecursiveIterator.prototype.destroy = function destroy() {
    this[QUEUE].length = 0;
    this[CACHE].length = 0;
    this[STATE] = null;
  };
  /**
   * @param {*} any
   * @returns {Boolean}
   */


  RecursiveIterator.prototype.isNode = function isNode(any) {
    return isObject(any);
  };
  /**
   * @param {*} any
   * @returns {Boolean}
   */


  RecursiveIterator.prototype.isLeaf = function isLeaf(any) {
    return !this.isNode(any);
  };
  /**
   * @param {*} any
   * @returns {Boolean}
   */


  RecursiveIterator.prototype.isCircular = function isCircular(any) {
    return this[CACHE].indexOf(any) !== -1;
  };
  /**
   * Returns states of child nodes
   * @param {Object} node
   * @param {Array} path
   * @param {Number} deep
   * @returns {Array<Object>}
   */


  RecursiveIterator.prototype.getStatesOfChildNodes = function getStatesOfChildNodes(node, path, deep) {
    var _this = this;

    return getKeys(node).map(function (key) {
      return _this.getState(node, node[key], key, path.concat(key), deep + 1);
    });
  };
  /**
   * Returns state of node. Calls for each node
   * @param {Object} [parent]
   * @param {*} [node]
   * @param {String} [key]
   * @param {Array} [path]
   * @param {Number} [deep]
   * @returns {Object}
   */


  RecursiveIterator.prototype.getState = function getState(parent, node, key) {
    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var deep = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    return { parent: parent, node: node, key: key, path: path, deep: deep };
  };
  /**
   * Callback
   * @param {Object} state
   * @returns {Boolean}
   */


  RecursiveIterator.prototype.onStepInto = function onStepInto(state) {
    return true;
  };
  /**
   * @returns {RecursiveIterator}
   */


  RecursiveIterator.prototype[Symbol.iterator] = function () {
    return this;
  };

  return RecursiveIterator;
}();

module.exports = RecursiveIterator;

/***/ }),

/***/ "z3JB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication__ = __webpack_require__("AXXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__recursive_iterator__ = __webpack_require__("yBmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__recursive_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__recursive_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__("DlMc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(query) {
    var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var token, headers, formData, _iterator, _isArray, _i, _ref3, _ref4, node, parent, key, id, body, response, result, error;

    return __WEBPACK_IMPORTED_MODULE_0__Users_mahathun_src_personal_nzd_review_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (query instanceof Function) {
              _context.next = 2;
              break;
            }

            throw new Error('Expected query to be a function');

          case 2:
            token = __WEBPACK_IMPORTED_MODULE_2__authentication__["a" /* default */].getToken();
            headers = {};


            if (token) {
              headers['Authorization'] = 'Bearer ' + token;
              variables.identity = token;
            }

            formData = new FormData();
            _iterator = new __WEBPACK_IMPORTED_MODULE_3__recursive_iterator___default.a(variables), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();

          case 7:
            if (!_isArray) {
              _context.next = 13;
              break;
            }

            if (!(_i >= _iterator.length)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt('break', 26);

          case 10:
            _ref3 = _iterator[_i++];
            _context.next = 17;
            break;

          case 13:
            _i = _iterator.next();

            if (!_i.done) {
              _context.next = 16;
              break;
            }

            return _context.abrupt('break', 26);

          case 16:
            _ref3 = _i.value;

          case 17:
            _ref4 = _ref3;
            node = _ref4.node, parent = _ref4.parent, key = _ref4.key;

            if (node instanceof File) {
              _context.next = 21;
              break;
            }

            return _context.abrupt('continue', 24);

          case 21:
            id = 'FILE-' + __WEBPACK_IMPORTED_MODULE_4_uuid___default.a.v4();

            formData.append(id, node);
            parent[key] = id;

          case 24:
            _context.next = 7;
            break;

          case 26:
            body = query(variables);


            formData.append('query', body.query);

            if (body.variables) {
              formData.append('variables', body.variables);
            }

            if (body.operationName) {
              formData.append('operationName', body.operationName);
            }

            _context.next = 32;
            return fetch('' + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api.host + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api.path, {
              method: 'POST',
              body: formData,
              headers: headers,
              credentials: 'include'
            });

          case 32:
            response = _context.sent;
            _context.next = 35;
            return response.json();

          case 35:
            result = _context.sent;

            if (!(result.errors || !result.data)) {
              _context.next = 40;
              break;
            }

            error = new Error(((result.errors || [])[0] || {}).message || 'Unexpected error while invoking endpoing');

            error.errors = result.errors;
            throw error;

          case 40:
            return _context.abrupt('return', result.data);

          case 41:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})());

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.b712dad0.js